import type { ReactNode } from "react";
import { AppBadge, type AppBadgeTom } from "@/components/ui/appBadge";

/** Chip de resumo (contagem por tom) usado no cabeçalho dos eventos. */
export default function ChipResumo({ tom, children }: { readonly tom: AppBadgeTom; readonly children: ReactNode }) {
	return <AppBadge color={tom}>{children}</AppBadge>;
}
